import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeReportByQB, QBLoadingKeys } from "../../slices/quickBooksSlice";
import { LoaderSpinner } from "../../components/LoaderSpinner";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { TYPE_OTHERS, TYPE_PRODUCTS, TYPE_REQUEST_BODY, TYPE_SHIPPING_ADDRESS, TYPE_TOKEN, TYPE_VENDOR } from "../../consts/quickBooksTypes";

const QBReport = () => {
    const {
        reportData,
        loadingKeys,
        loading
    } = useSelector((state) => state.quickBooks);

    const dispatch = useDispatch();
    const [openIndexes, setOpenIndexes] = useState([]);
    useEffect(() => {
        dispatch(makeReportByQB({}));
    }, [])
    useEffect(() => {
        if (reportData && reportData.length > 0) {
            setOpenIndexes(reportData.map((_, index) => index));
        }
    }, [reportData]);

    const handleToggle = (index) => {
        setOpenIndexes((prev) =>
        prev.includes(index) 
            ? prev.filter((i) => i !== index)
            : [...prev, index]
        );
    };

    const typeNames = {
        [TYPE_SHIPPING_ADDRESS]: "Shipping address",
        [TYPE_OTHERS]: "Others",
        [TYPE_PRODUCTS]: "Products",
        [TYPE_REQUEST_BODY]: "Validation request body",
        [TYPE_TOKEN]: "Token",
        [TYPE_VENDOR]: "Vendor"
    }

    const reportDataIsLoading = loading && loadingKeys.includes(QBLoadingKeys.report);
    const getDefaultItemName = (type) => {
        return typeNames[type] || type;
    }

    return (
        <main className="w-full h-full px-4 sm:px-6 lg:px-8">
            {reportDataIsLoading ? (
                <div className="h-5/6 w-full absolute">
                    <LoaderSpinner colorSpinner="black" width="70" height="70" border="5" />
                </div>
            ) : (
                <section className="bg-white rounded-lg shadow-md overflow-hidden relative p-6 mt-8 h-full mb-8">
                    {(reportData || []).map((item, index) => (
                        <div key={index}>
                            <button
                                onClick={() => handleToggle(index)}
                                className="w-full px-4 py-2 flex items-center justify-between gap-4 mb-2 bg-black text-left text-white text-base rounded-lg cursor-pointer"
                            >
                                {getDefaultItemName(item?.type)}
                                <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
                            </button>
                            {openIndexes.includes(index) && (
                                <div>
                                    {(item?.errors || []).map((error, indexError) => (
                                        <div
                                            key={indexError}
                                            className="mb-2 p-4 border border-gray-200 bg-white rounded-md text-sm"
                                        >
                                            <strong className="block mb-2">{error?.poNumber}</strong>
                                            <pre>{error?.error}</pre>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </section>
            )}
        </main>
    )
};

export default QBReport;